import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Api from "../../Api";
import QuoteDisplay from "../../parts/quote/Display";
import DiscreetMessage from "../../parts/DiscreetMessage";
import { Client, Quote, User } from "../../types";

const MyQuotesView = () => {
  const { uuid } = useParams();
  const [quote, setQuote] = useState<Quote | null>(null);
  const [client, setClient] = useState<Client | null>(null);
  const [seller, setSeller] = useState<User | null>(null);
  const [equipmentMap, setEquipmentMap] = useState<Record<
    string,
    string
  > | null>(null);

  useEffect(() => {
    Api.myQuotesGetByUuid(uuid!).then(
      ({ quote, client, seller, equipmentMap }) => {
        setQuote(quote);
        setClient(client);
        setSeller(seller);
        setEquipmentMap(equipmentMap);
      }
    );
  }, [uuid]);

  if (!quote) return <DiscreetMessage text="Carregando ..." />;

  return (
    <div>
      <QuoteDisplay
        quote={quote!}
        client={client!}
        seller={seller!}
        equipmentMap={equipmentMap!}
      />
    </div>
  );
};

export default MyQuotesView;
